import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { SiteTypesService } from 'app/_services/site-types.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-site-types',
  templateUrl: './site-types.component.html',
})
export class SiteTypesComponent implements OnInit {
  siteTypes: any[];
  selectedSiteType: any = [];

  role: any;
  routeRole: any;

  errorAlerts;

  createSiteTypeModal = false;
  createSiteTypeForm: FormGroup;

  editSiteTypeModal = false;
  editSiteTypeForm: FormGroup;

  constructor(public router: Router, public globals: Globals, public fb: FormBuilder, public siteTypesService: SiteTypesService) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.createSiteTypeForm = fb.group({
      name: new FormControl('', [Validators.required]),
    });

    this.editSiteTypeForm = fb.group({
      name: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.getAllSiteTypes();
  }

  public getAllSiteTypes() {
    this.siteTypesService.getAllSiteTypesNoPagination().subscribe((data: any) => {
      this.siteTypes = data;
    });
  }

  public toggleCreateSiteTypeModal() {
    this.createSiteTypeModal = !this.createSiteTypeModal;
  }

  public onCreateSiteTypeFormSubmit() {
    const values = this.createSiteTypeForm.value;
    const body = {
      name: values.name,
    };
    this.siteTypesService.createSiteType(body).subscribe((data: any) => {
      this.createSiteTypeForm.reset();
      this.toggleCreateSiteTypeModal();
      this.getAllSiteTypes();
      Swal.fire('Success', 'Site Type Created!', 'success');
    });
  }

  public onRowSelect(event) {
    this.selectedSiteType = event.data;
    this.editSiteTypeForm.patchValue({
      name: event.data.name,
    });
    this.toggleEditSiteTypeModal();
  }

  public toggleEditSiteTypeModal() {
    this.editSiteTypeModal = !this.editSiteTypeModal;
  }

  public onEditSiteTypeFormSubmit() {
    const values = this.editSiteTypeForm.value;
    const body = {
      name: values.name,
      id: this.selectedSiteType.id,
    };
    this.siteTypesService.editSiteType(body).subscribe((data: any) => {
      this.editSiteTypeForm.reset();
      this.toggleEditSiteTypeModal();
      this.getAllSiteTypes();
      Swal.fire('Success', 'Site Type Updated!', 'success');
    });
  }
}
